import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import history from './history'
import useAppContext from '../hooks/useAppContext'
import utils from '../utils/utils'

// Subcomponents
import PrivateRoute from './PrivateRoute'
import ModalOnlyOneTab from '../components/ModalOnlyOneTab'
import PopupBonuses from '../components/PopupBonuses'
import WizardPrivate from '../components/WizardPrivate'
import VerificationSMSPayment from '../components/VerificationSMSPayment'
import ModalLevelUp from '../components/ModalLevelUp/ModalLevelUp'
import PopupWelcome from '../components/PopupWelcome'
import { PopupCashoutsPending } from '../components/Retirar/PopupCashoutsPending'

// Route Pages Components
import Book from '../components/Book'
import Home from '../components/Home'
import Ayuda from '../components/Ayuda'
import NoMatch from '../components/NoMatch'
import UserInfo from '../components/UserInfo'
import Quiniela from '../components/Quiniela'
import Terminos from '../components/Terminos'
import Slots from '../components/Slots/Slots'
import LobbyUsers from '../components/LobbyUsers'
import Promotions from '../components/Promotions'
import RegistroFB from '../components/RegistroFB'
import EvCasino from '../components/EvCasino/EvCasino'
import MisQuinielas from '../components/MisQuinielas'
import BracketsLobby from '../components/BracketsLobby'
import ErrorBoundary from '../components/ErrorBoundary'
import SurvivorLobby from '../components/SurvivorLobby'
import RecuperarPass from '../components/RecuperarPass'
import ErrorComponent from '../components/ErrorComponent'
import ValidarUsuario from '../components/ValidarUsuario'
import SportRules from '../components/SportRules/SportRules'
import BracketsPointsLobby from '../components/BracketPointsLobby'
import QuinielaGroupsLobby from '../components/QuinielaGroupsLobby'
import BracketsPerfectLobby from '../components/BracketPerfectLobby'
import PanelSmsVerification from '../components/PanelSmsVerification'
import EditarQuinielaPrivada from '../components/EditarQuinielaPrivada'
import FirstTimeDownloadPanel from '../components/FirstTimeDownloadPanel'
import ResponsibleGaming from '../components/ResponsibleGaming/ResponsibleGaming'
import BracketTennisLobby from '../components/BracketTennisLobby/BracketTennisLobby'
import Terminos2025 from '../components/Terminos2025'
import { KambiSportsbook } from '../components/KambiSportsbook'
import KambySportRules from '../components/KambySportRules'
import { ModalOldWagersPariplay } from '../components/KambiSportsbook'
import { RedirectPool } from '../components/RedirectPool/RedirectPool'
import { SlotsPage } from '../modules/slots'
import { AuthModal, AuthPage, ResetPasswordPage, CloseSessionsPage } from '@/modules/auth'

const Routes = () => {
  const { isNetworkAvailable } = useAppContext()

  if (!isNetworkAvailable) {
    return (
      <Router history={history}>
        <Route component={ErrorComponent} />
      </Router>
    )
  }

  return (
    <Router history={history}>
      <>
        <AuthModal />
        <ModalOnlyOneTab />
        <PopupBonuses />
        <WizardPrivate />
        <ModalLevelUp />
        <VerificationSMSPayment />
        <PopupWelcome />
        <PopupCashoutsPending />
        <ModalOldWagersPariplay />
        <Switch>
          <Route
            exact
            path='/lobby'
            state={utils.detectDevice()}
            component={(props) => <Home deviceType={utils.detectDevice()} {...props} />}
          />
          <Route
            exact
            path='/lobby/quinielaPop/:slug/:poolId/'
            component={(props) => <Home deviceType={utils.detectDevice()} {...props} />}
          />
          <Route
            exact
            path='/lobby/quinielaGrupoPop/:slug/:poolGroupId/'
            component={(props) => <Home deviceType={utils.detectDevice()} {...props} />}
          />
          <Route
            exact
            path='/lobby/survivorPop/:slug/:survivorId/'
            component={(props) => <Home deviceType={utils.detectDevice()} {...props} />}
          />
          <Route
            exact
            path='/lobby/bracketPop/:slug/:bracketId/'
            component={(props) => <Home deviceType={utils.detectDevice()} {...props} />}
          />
          <PrivateRoute path='/lobby_usuarios' component={LobbyUsers} />
          <PrivateRoute path='/mis_quinielas' component={MisQuinielas} />
          <PrivateRoute path='/usuario/' component={UserInfo} />
          <PrivateRoute
            gameType='quiniela'
            path='/quiniela/:slug/:poolId/:entryId?'
            component={Quiniela}
          />
          <Route path='/quiniela/:id?' component={RedirectPool} />
          <PrivateRoute
            gameType='quinielaGrupo'
            path='/quinielaGrupo/:slug/:poolGroupId/:entryId?'
            component={QuinielaGroupsLobby}
          />
          <PrivateRoute
            exact
            gameType='bracket'
            path='/bracket/:slug/:bracketId/:bracketEntryId?'
            component={BracketsLobby}
          />
          <PrivateRoute
            exact
            gameType='bracketPerfect'
            path='/bracketPerfect/:slug/:bracketId/:bracketEntryId?'
            component={BracketsPerfectLobby}
          />
          <PrivateRoute
            exact
            gameType='bracketPoints'
            path='/bracketPoints/:slug/:bracketId/:bracketEntryId?'
            component={BracketsPointsLobby}
          />
          <PrivateRoute
            exact
            gameType='bracketTennis'
            path='/bracketTennisLobby/:slug/:bracketId/:bracketEntryId?'
            component={BracketTennisLobby}
          />
          <PrivateRoute
            exact
            gameType='survivor'
            path='/survivor/:slug/:survivorId/:survivorEntryId?'
            component={SurvivorLobby}
          />
          <Route exact path='/' component={KambiSportsbook} />
          <PrivateRoute exact path='/casino' component={EvCasino} />
          <PrivateRoute exact path='/slots' component={SlotsPage} />
          <PrivateRoute path='/editar/:gameType/:privadaId' component={EditarQuinielaPrivada} />
          <Route exact path='/ingresar' component={AuthPage} />
          <Route exact path='/registrate/FB' component={RegistroFB} />
          <Route exact path='/registrate' component={AuthPage} />
          <Route path='/verificarCuenta' component={PanelSmsVerification} />
          <Route path='/password_perdido' component={RecuperarPass} />
          <Route exact path='/descargar_app' component={FirstTimeDownloadPanel} />
          <Route exact path='/reset_password/:token' component={ResetPasswordPage} />
          <Route path='/ayuda' component={Ayuda} />
          <Route path='/validar-usuario' component={ValidarUsuario} />
          <Route path='/close-sessions' component={CloseSessionsPage} />
          <Route
            exact
            path='/legal/terminos'
            render={() => {
              return <Terminos2025 />
            }}
          />
          <Route
            exact
            path='/legal/terminos-20250501'
            render={() => {
              return <Terminos2025 />
            }}
          />
          <Route
            exact
            path='/legal/privacidad'
            render={() => {
              return <Terminos which='privacidad' />
            }}
          />
          <Route
            exact
            path='/legal/legales'
            render={() => {
              return <Terminos which='legales' />
            }}
          />
          <Route
            exact
            path='/legal/reglas-deportes'
            render={() => {
              return <KambySportRules />
            }}
          />
          <Route exact path='/promociones' component={Promotions} />
          <Route
            exact
            path='/legal/responsible-gaming'
            render={() => {
              return <ResponsibleGaming />
            }}
          />
          <PrivateRoute path='/salir' component={Home} />
          <Route path='/error' component={ErrorBoundary} />
          <Route component={NoMatch} />
        </Switch>
      </>
    </Router>
  )
}

export default Routes
